import loadScript from "./loadScript"

const STUBS = [
    "init", "startTracking", "stopTracking", "track", "resetIdentity", "identify",
    "identifyHashed", "getSessionId", "getUserId", "getIdentity", "addUserProperties",
    "addEventProperties", "removeEventProperty", "clearEventProperties",
    "addAccountProperties", "addAdapter", "addTransformer", "addTransformerFn",
    "onReady", "addPageviewProperties", "removePageviewProperty",
    "clearPageviewProperties", "trackPageview",
]

export function initHeapStubs() {
    if (typeof window === "undefined") return;
    window.heapReadyCb = window.heapReadyCb || [];
    window.heap = window.heap || [];
    if (window.heap.__stubbed) return;
    window.heap.__stubbed = true;

    STUBS.forEach(name => {
        window.heap[name] = function (...args) {
            window.heapReadyCb.push({
                name,
                fn: () => { if (window.heap[name]) window.heap[name].apply(window.heap, args) },
            });
        }
    });
}

export function loadHeap(envId) {
    if (typeof window === "undefined") return Promise.resolve();
    
    initHeapStubs();
    if (window.heap.__loading) return window.heap.__loading;

    window.heap.envId = String(envId);
    window.heap.clientConfig = { shouldFetchServerConfig: false };
    window.heap.__loading = loadScript(`https://cdn.us.heap-api.com/config/${envId}/heap_config.js`);
    return window.heap.__loading;
}

export function heapIdentify(globalNavUser) {
    if (!window.heap || !globalNavUser) return;

    try {
        window.heap.identify(globalNavUser.email);
        window.heap.addUserProperties({
            name: globalNavUser.name,
            email: globalNavUser.email,
            external_id: globalNavUser.id
        });
    } catch (err) {
        console.warn("Heap failed to identify:", err);
    }
}

export function trackHeapOrder(order) {
    const data = {
        purchase_qty: order.purchase_qty,
        purchase_value: order.purchase_value,
        purchase_skus: order.purchase_skus,
        purchase_date_latest: order.purchase_date_latest,
        purchase_count: order.purchase_count,
        purchase_date_first: order.purchase_date_first
    }
    if (typeof window !== 'undefined' && window.heap) {
        window.heap.track('Purchase', data);
    }
}
